<div class="usage-report-div">GDS Usage Reports</div>
<div>
  <div class="usage-main-div">
    <div class="usage-report">
      <span>Type of Report To Build</span>
    </div>
    <div class="usage-report">
      <fieldset ngl-radio-group >
        <ngl-radio-option label="Rate Audit"><input ngl type="radio" [checked]="true"  (click)="buildSAUsageReport($event)"/></ngl-radio-option><br>
        <ngl-radio-option label="Rate Availability"><input ngl type="radio"   (click)="buildRIUsageReport($event)"/></ngl-radio-option><br>
        <ngl-radio-option label="Reverse Audit"><input ngl type="radio" [disabled]="true" /></ngl-radio-option><br>
        <ngl-radio-option label="BAR Shopping" *ngIf="showBAROption"><input ngl type="radio"   (click)="buildBARUsageReport($event)"/></ngl-radio-option>
      </fieldset>

    </div>
    <div class="usage-report">
      Start Date :
      <kendo-datepicker [value]="initialFilterStartDate" (valueChange)="onStartDateChange($event)"></kendo-datepicker>
      End Date :
      <kendo-datepicker [value]="initialFilterEndDate" (valueChange)="onEndDateChange($event)"> </kendo-datepicker>
    </div>
    <div class="usage-report">
      <span>GDSs To  Include</span>
    </div>
    <div class="usage-report">
      <table>
        <tr>
            <td>
              <ngl-checkbox label="Amadeus">
                <input ngl type="checkbox" [(ngModel)]="selectedAmadeus"  name="Amadeus" />
            </ngl-checkbox>
            </td>
            <td>
              <ngl-checkbox label="Apollo">
                <input ngl type="checkbox" [(ngModel)]="selectedApollo"  name="Apollo" />
            </ngl-checkbox>
          </td>
            <td>
              <ngl-checkbox label="Galileo">
                <input ngl type="checkbox" [(ngModel)]="selectedGalileo"  name="Galileo" />
            </ngl-checkbox>
          </td>
        </tr>
        <tr>
          <td>
           <ngl-checkbox label="Sabre">
                <input ngl type="checkbox" [(ngModel)]="selectedSabre"  name="Sabre" />
            </ngl-checkbox>
          </td>
          <td>
            <ngl-checkbox label="Worldspan">
                <input ngl type="checkbox" [(ngModel)]="selectedWorldspan"  name="Worldspan" />
            </ngl-checkbox>
          </td>

        </tr>
      </table>
    </div>
  </div>

  <div class="usage-main-div-right" *ngIf="showAccountList">
    <div class="usage-report">
      <ngl-checkbox label="Available Account(s)">
                <input ngl type="checkbox"   name="all" [(ngModel)]="selectedAll"   (change)="checkAll($event)"/>
      </ngl-checkbox>
    </div>
    <div class="accountname-list">
      <table>
        <tr *ngFor="let account of accountNameList; let i = index">
          <td>
            <ngl-checkbox label={{account}}>
                <input ngl type="checkbox"  id="{{ 'account_checkbox' + i }}" [(ngModel)]="selectedAccountNames[i]" class="selectAllCheckbox" (change)="updateCheckall($event)" />
            </ngl-checkbox>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div class="usage-button">
  <button class="k-button cvt-primary cvt-kendobutton " (click)="onBuildReport()">Build Report</button>
</div>

 <div kendoDialogContainer *ngIf='kendoDialog' ></div>
<app-modal (onOkToParent)='okButtonClick()'   (onCloseToParent)='closeModals()' *ngIf='openModal'
[dialogTitle]="dialogTitle"
[dialogTextLine1]="dialogTextLine1"
[dialogTextLine2]="dialogTextLine2"
[primaryButtonText]="primaryButtonText"
[secondaryButtonText]="secondaryButtonText"
></app-modal>
